import {useEffect, useState} from 'react';

export function isSintonizyAndroidApp(): boolean {
  if (typeof window === 'undefined') return false;

  return Boolean(
    (window as any).__SINTONIZY_ANDROID_APP__ ||
      /SintonizyAndroid/i.test(window.navigator?.userAgent || ''),
  );
}

export function useIsSintonizyAndroidApp(): boolean {
  const [isAndroidApp, setIsAndroidApp] = useState(isSintonizyAndroidApp);

  useEffect(() => {
    if (isAndroidApp || typeof window === 'undefined') return;

    const syncAndroidAppState = () => {
      setIsAndroidApp(isSintonizyAndroidApp());
    };

    window.addEventListener(
      'sintonizy-android-app-ready',
      syncAndroidAppState,
    );
    const timeoutId = window.setTimeout(syncAndroidAppState, 250);

    return () => {
      window.removeEventListener(
        'sintonizy-android-app-ready',
        syncAndroidAppState,
      );
      window.clearTimeout(timeoutId);
    };
  }, [isAndroidApp]);

  return isAndroidApp;
}
